import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ReactApexChart from 'react-apexcharts';
import { API_BASE_URL } from '../..//config'; // adjust path if needed

const DeptAttendanceLine = () => {
  const [categories, setCategories] = useState([]); // dept names
  const [series, setSeries] = useState([{ name: 'Present', data: [] }]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
     const token = localStorage.getItem('authToken');
    const load = async () => {
      try {
        // Match your route/controller name:
        // If your route is /api/attendance/department-split, change below accordingly
        const { data } = await axios.get(`${API_BASE_URL}/departmentAttendanceSplit`, {
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' }
    });
        const rows = data?.data || [];
        console.log(rows.map(r => r.label));

        setCategories(rows.map(r => r.label));
        setSeries([{ name: 'Present', data: rows.map(r => Number(r.value || 0)) }]);
      } catch (e) {
        setErr('Failed to load department split');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <div>Loading…</div>;
  if (err) return <div style={{ color: 'crimson' }}>{err}</div>;
  if (!categories.length) return <div>No data for today.</div>;

 const options = {
  chart: { type: 'line', toolbar: { show: false } },
  colors: ['#FF6B6B'],                 // must be an array
  stroke: { curve: 'smooth', width: 2 },
  markers: { size: 4, colors: ['#FF6B6B'], strokeColors: '#FF6B6B' },
  dataLabels: { enabled: false },
  xaxis: {
    type: 'category',
    categories,
    title: { text: 'Departments' },
    labels: { rotate: -30, trim: true },
  },
  yaxis: {
    title: { text: 'Employees Present' },
    min: 0,
    decimalsInFloat: 0,
  },
  tooltip: { y: { formatter: (val) => `${val} present` } },
  legend: { show: false },
};


  return (
    <div>
      <h4 className="mb-2">Present by Department (Today)</h4>
      <ReactApexChart options={options} series={series} type="line" height={340} />
    </div>
  );
};

export default DeptAttendanceLine;
